<!-- eslint-disable vue/no-unused-vars -->
<template>
  <!-- <div class="general-form" v-if="customer"> -->
	<div class="personal-detail-form">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form" class="mt-4">
				<b-row>
					<b-col cols="8">
						<b-form-group label="Customer Name" label-class="required-label"
							description="Please enter Customer Name as per NRIC">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true, name: true }" :vid="'customerName'">
								<el-input v-model="form.general.name" type="text" placeholder="Enter name"></el-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-form-group label="Company Registration No.">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'companyRegistrationNo'">
								<el-input v-model="form.general.company_registration_no" type="text" placeholder="Enter Company Registration No."></el-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="8" v-if="form.general.is_foreigner == 0">
						<b-form-group label="Customer NRIC">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true, nric:true, nric_check:true }" :vid="'nric'">
								<el-input v-model="form.general.nric" type="text" placeholder="Enter nric"></el-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-form-group label="Contact No.">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.general.contact_no" type="text" maxlength="17" placeholder="Enter contact number"
									@keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-form-group label="Email Address">
							<ValidationProvider v-slot="{ errors }" :rules="{ email: true }" :vid="'email'">
								<el-input v-model="form.general.email" type="email" placeholder="Enter email"></el-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-form-group label="Address" label-class="required-label">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true, }">
								<el-input v-model="form.location1.address_1" type="text" placeholder="Please enter the address"></el-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-row>
							<b-col md="4" cols="12">
								<b-form-group label="States">
									<el-select v-model="form.location1.state_id" placeholder="Select">
										<el-option :value="null"></el-option>
										<el-option v-for="item in tables.states" :key="item.name" :label="item.name" :value="item.state_id"></el-option>
									</el-select>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="City">
									<el-input v-model="form.location1.city" type="text" placeholder="Enter city"></el-input>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label="Postcode">
									<ValidationProvider v-slot="{ errors }" :rules="{ postcode: true }" :vid="'postcode'">
										<el-input v-model="form.location1.postcode" type="text" placeholder="Enter postcode"></el-input>
										<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
									</ValidationProvider>
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="8">
						<b-form-group label="Marital Status">
							<el-radio-group v-model="form.general.marital_status">
								<el-radio :label="'Single'" v-model="form.general.marital_status">Single</el-radio>
								<el-radio :label="'Married'" v-model="form.general.marital_status">Married</el-radio>
							</el-radio-group>
						</b-form-group>
					</b-col>
					<b-col md="8" cols="12">
						<b-form-group label="Race">
							<el-radio-group v-model="form.general.race" fill="#13663E">
								<el-radio-button label="Chinese"></el-radio-button>
								<el-radio-button label="Malay"></el-radio-button>
								<el-radio-button label="Indian"></el-radio-button>
								<el-radio-button label="Others"></el-radio-button>
							</el-radio-group>
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-button block variant="primary" class="w-50" @click.prevent="update()">Save</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</div>
</template>
<script>
import { DatePicker, Radio, RadioGroup, RadioButton, Select, Option, Checkbox, Button } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { mapState, mapActions } from 'pinia';
import { preventNonNumericInput } from '@/assets/js/formValidations.js'

export default {
	name: 'general-form',
	components: {
		ValidationObserver,
		ValidationProvider,
		[DatePicker.name]: DatePicker,
		[Radio.name]: Radio,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
		[Button.name]: Button,
	},
	data() {
		return {
			has_diff_residential: true,
			form: {
				general: {
					name: '',
					company_registration_no: '',
					is_foreigner: 0,
					dob: '',
					nric: '',
					email: '',
					contact_no: '',
					gender: '',
					cob_id: '',
					race: '',
					marital_status: '',
					nationality_id: '',
					length_of_stay: ''
				},
				location1: {},
				location2: {},
			},
			tables: {
				states: []
			}
		}
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer']),
	},
	created() {
		this.getStates();
		this.form.general = this.activeCustomer;
		this.form.location1 = this.activeCustomer.locations?.nric || {};
		this.form.location2 = this.activeCustomer.locations?.residential || {};
	},
	methods: {
		preventNonNumericInput,
		...mapActions(useCustomerStore, ['updateCustomerGeneralInfo', 'updateCustomerLocation']),
		...mapActions(useCommonStore, ['getTables']),
		update() {
			let calls = [
				this.updateCustomerGeneralInfo(this.activeCustomer.im2u_id, this.form.general)
			]
			if (
				this.form.location1.address_1 ||
				this.form.location1.state_id ||
				this.form.location1.city ||
				this.form.location1.postcode
			) {
				this.form.location1.type = 'nric';
				let state = this.tables.states.find(state => state.state_id == this.form.location1.state_id);
				this.form.location1.country_id = state ? state.country_id : null;
				const locations = {
					locations: [this.form.location1]
				};
				calls.push(this.updateCustomerLocation(this.activeCustomer.im2u_id, locations))
			}

			Promise.all(calls)
				.then(responses => {
					_gNotif.notifySuccess('<b>Customer: ' + responses[0].data.name + '</b> - Successfully Updated.')
				})
				.catch(e => {
					_gNotif.errorFunction(e.message);
				})
		},
		getStates() {
			this.getTables('states').then(resp => {
				this.tables.states = resp.states;
			});
		}
	},

}
</script>

<style>
.el-radio-button__inner:hover {
  color: #13663E;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #13663E;
  background: #13663E;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #13663E;
}
</style>